export function trimContent(value) {
  return value?.replaceAll(/(\r\n|\n|\r)/gm, '').trim();
}
